import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {RuleFile} from './instruction-plugin-source'

// The web client renders image bytes directly from the originating tool result.
const LOCAL_IMAGES_RULE: RuleFile = {
  name: 'github-web-local-images.mdc',
  content: `---
description: Showing image files in the GitHub web client
alwaysApply: true
---

The GitHub web client displays images returned by tools directly from the tool result. When a screenshot, image generation, \`view\`, or another tool already returned the image bytes, do not call \`view\` again and do not repeat the image with Markdown.

If an image exists only as a file and no tool result has returned its bytes, call \`view\` on the path once. The \`view\` result displays the image; do not add a Markdown image reference afterward.`,
}

/** Adds instruction rules the web client contributes to every relay that accepts instruction rules. */
export function withClientInstructionRules(rules: RuleFile[]): RuleFile[] {
  return isFeatureEnabled('copilot_mission_control_ahp_local_images') ? [...rules, LOCAL_IMAGES_RULE] : rules
}
